import { render, staticRenderFns } from "./info-alert.vue?vue&type=template&id=77a267a4&scoped=true"
import script from "./info-alert.vue?vue&type=script&lang=js"
export * from "./info-alert.vue?vue&type=script&lang=js"
import style0 from "./info-alert.vue?vue&type=style&index=0&id=77a267a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a267a4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HIcon: require('/home/runner/work/frontpages/frontpages/component-library/src/components/atoms/icons/h-icon.vue').default})
